import classNames from 'classnames/bind'
import React from 'react'
import PropTypes from 'prop-types'

import styles from './QuestionOptions.module.scss'

const cx = classNames.bind(styles)

const QuestionOptions = ({ options }) => (
  <div className={styles.alternative}>
    {options.map(option => {
      const sequenceClasses = cx('letter', { 'correct-letter': option.correct })
      const correctTextClasses = cx('text', { 'correct-text': option.correct })
      return (
        <div className={styles.sequence}>
          <span className={sequenceClasses}>{option.sequence}</span>
          <span className={correctTextClasses} dangerouslySetInnerHTML={{ __html: option.text }} />
        </div>
      )
    })}
  </div>
)

QuestionOptions.propTypes = {
  options: PropTypes.array.isRequired,
}

export default QuestionOptions
